import { Injectable } from '@angular/core';
import { HttpApiServiceBase } from './http-api-service-base';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Pms } from '../domain/pms';
import { PropertyPmsResponse } from './response/property-pms-response';
import { Organisation } from '../domain/organisation';

@Injectable({
   providedIn: 'root'
})
export class PmsService extends HttpApiServiceBase {
   constructor(private http: HttpClient) {
      super();
   }

   getAllPms(): Observable<Pms[]> {
      return this.http.get<Pms[]>(`${environment.apiEndpoint}/pms`);
   }

   getPropertyPms(propId: number): Observable<PropertyPmsResponse> {
      return this.http.get<PropertyPmsResponse>(
         `${environment.apiEndpoint}/pms/property/${encodeURIComponent(propId)}`
      );
   }

   addPropertyToPms(propId: number, pmsId: number): Observable<PropertyPmsResponse> {
      return this.http.post<PropertyPmsResponse>(
         `${environment.apiEndpoint}/pms/${encodeURIComponent(pmsId)}/property/${encodeURIComponent(propId)}`,
         {}
      );
   }

   getOrganisationsForPms(pmsId: number): Observable<Organisation[]> {
      return this.http.get<Organisation[]>(
         `${environment.apiEndpoint}/pms/${encodeURIComponent(pmsId)}/organisation`
      );
   }
}
